import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Loader from '@/components/ui/Loader/Loader'
import { logger, LOGGER_LEVEL } from '@/network/common/logger'
import { useAppStatus } from '@/providers/firebase/Firebase.provider'

import { checkInternetConnection, NetworSpeed } from '../ErrorNetworkHandler/ErrorNetworkHandler'

import './ErrorNetworkLoadingPage.scss'

const ErrorNetworkLoadingPage = () => {
  const { t } = useTranslation()
  const [speed, setSpeed] = useState<NetworSpeed>(NetworSpeed.FAST)
  const { logsAreEnabled } = useAppStatus()

  const logNetworkSpeed = async () => {
    checkInternetConnection().then(({ networkSpeed, networkSpeedInMbPerSecond }) => {
      setSpeed(networkSpeed)
      if (!logsAreEnabled) {
        return
      }

      if (networkSpeed === NetworSpeed.SLOW) {
        logger({
          level: LOGGER_LEVEL.WARN,
          message: `Slow network speed detected`,
          meta: { networkSpeedInMbPerSecond: networkSpeedInMbPerSecond },
          shouldSendToServer: true,
        })
      } else if (networkSpeed === NetworSpeed.NO_INTERNET) {
        logger({
          level: LOGGER_LEVEL.WARN,
          message: `No internet connection detected`,
          meta: { networkSpeedInMbPerSecond: networkSpeedInMbPerSecond, shouldSendToServer: true },
        })
      } else if (networkSpeed === NetworSpeed.UNKNOWN) {
        logger({
          level: LOGGER_LEVEL.WARN,
          message: `Unknown network speed detected`,
          meta: { networkSpeedInMbPerSecond: networkSpeedInMbPerSecond, shouldSendToServer: true },
        })
      }
    })
  }

  useEffect(() => {
    logNetworkSpeed()
  }, [])

  return (
    <div className="loading-page">
      <Loader />
      <h1>{t('NetworkLoadingPageTitle')}</h1>
      {speed === NetworSpeed.SLOW && <p>{t('NetworkLoadingPageSlowNetwork')}</p>}
      {speed === NetworSpeed.NO_INTERNET && <p>{t('NetworkLoadingPageNoInternet')}</p>}
      {speed === NetworSpeed.UNKNOWN && <p>{t('NetworkLoadingPageUnknownNetwork')}</p>}
    </div>
  )
}

export default ErrorNetworkLoadingPage
